<!--
    Reemplazo del EmptyState previo. Misma ruta, API cerrada:
    icon, title, description, actionText, actionLink, $emit('action').
    Migrado al Design System 2026-07.
-->
<template>
    <div class="flex flex-col items-center justify-center text-center px-4 py-12">
        <div v-if="icon" :class="['w-20 h-20 rounded-2xl flex items-center justify-center mb-5', iconBgClass]">
            <Icon :name="icon" size="xl" :tone="iconTone" />
        </div>
        <h3 class="text-lg font-semibold text-stone-900">{{ title }}</h3>
        <p v-if="description" class="text-sm text-stone-500 mt-2 max-w-md leading-relaxed">{{ description }}</p>
        <div v-if="$slots.actions || actionText" class="mt-6 flex items-center gap-2">
            <slot name="actions">
                <Button v-if="actionText" :variant="actionVariant" :icon-left="actionIcon" @click="$emit('action')">
                    {{ actionText }}
                </Button>
            </slot>
        </div>
    </div>
</template>

<script>
import Icon from './Icon.vue';
import Button from './Button.vue';
export default {
    name: 'EmptyState',
    components: { Icon, Button },
    emits: ['action'],
    props: {
        icon: { type: String, default: '' },
        title: { type: String, required: true },
        description: { type: String, default: '' },
        actionText: { type: String, default: '' },
        actionVariant: { type: String, default: 'secondary' },
        actionIcon: { type: String, default: '' },
        tone: {
            type: String,
            default: 'neutral',
            validator: (v) => ['neutral', 'warm'].includes(v),
        },
    },
    computed: {
        iconBgClass() {
            return this.tone === 'warm' ? 'bg-amber-50' : 'bg-stone-50';
        },
        iconTone() {
            return this.tone === 'warm' ? 'primary' : 'muted';
        },
    },
};
</script>
